<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　
    <div class="clublistbox">
      <!-- <div class="clubboximg">
        <a href="javascript:void(0)" @click="gotoClubdes"><img src="~assets/images/club/1.jpg" alt="" /></a>
      </div> -->
      <div class="clubtitle">
        俱乐部列表
      </div>
      <div class="clubbox" v-for="item in clubList" :key="item.id">
        <a href="javascript:void(0)" @click="gotoClubdes(item.id)">
          <div
            class="clubminbox"
          
          >
            <div class="leftbox">
              <div class="racetitle">{{ item.clubName }}</div>
              <div class="clubdes">
                {{ item.introduce }}
              </div>

              <div class="racebtn">查看此俱乐部 ></div>
            </div>

            <div class="midbox">
              <p>地址：{{ item.address }}</p>
              <p>营业时间：{{ item.openTime }}</p>
              <p>联系电话：{{ item.userPhone }}</p>
            </div>
            <div class="rightbox">
              <div class="raceimg">
                <img :src="item.clubUrl" alt="" />
                <!-- <img src="~assets/images/race/raceitem2.jpg" alt="" /> -->
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    　
    <footerBlock></footerBlock>
  </div>
</template>

<script>
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
import axios from "axios"; // 导入 Axios

export default {
  name: "clublist",
  data() {
    return {
      msg: "",
      clubList: [],
      bgColor: "#181818", // 初始背景颜色
    };
  },
  components: {
    footerBlock,
    myheadBlock,
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
  },
  methods: {
    gotoHomePage: function () {
      this.$router.push({
        name: "Home",
      });
    },
    gotoClubdes: function () {
      this.$router.push({
        name: "clubdes",
      });
    },

    gotoClubdes: function (id) {
      console.log("clubid=" + id);
      this.$router.push({
        name: "clubdes",
        params: { id: id },
      });
    },

    async CheckClubList() {
      // console.log("CheckClubList");
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const params = {
          page: 1,
          size: 10,
        };

        const url = "https://ttserver.aizhuotice.online/api/v1/clubInfo/page";
        const response = await axios.get(url, {
          params: params,
          headers: {
            "Content-Type": "application/json",
            // token: this.token,
          },
        });

        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        console.log(this.response);
        if (this.response.code == 200) {
          // console.log(this.response.data);
          this.clubList = this.response.data.data;

          console.log(this.clubList.length);

          console.log(this.raceList);

          this.clubList.forEach(element => {
            element.clubUrl = element.clubImage;
          });
          // this.isShowLoginBtn = false;
        } else {
          // this.isShowLoginBtn = true;
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.CheckClubList();
  },
  created() {
    // this.CheckClubList();
  },
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.clubbox {
  width: 100vw;
  height: 150vw;
  position: relative;
}

.clubboximg {
  width: 100%;
  height: 100%;
}

.clubboximg img {
  width: 100%;
  height: 100%;
}

.hometiebtnimg {
  position: absolute;
  top: 37.5vw;
  left: 38vw;
  width: 25.5vw;
  height: 5.5vw;
}

.hometiebtnimg img {
  width: 100%;
  height: 100%;
}

.hometiebox2 {
  width: 100vw;
  height: 56.7vw;
  position: relative;
}

.clubtitle{
position: relative;
top: 3vw;
left: 3vw;
width: 100%;
height: 10vw;
font-size: 4vw;
font-weight: bold;
color: #a81f24;
text-align: center;
}
.clublistbox {
  background-color: #181818;
}

.clubbox {
  position: relative;
  width: 100vw;
  height: 34.1vw;
  background-color: #181818;
}
.clubminbox {
  position: relative;
  width: 100%;
  height: 34vw;
  border-bottom: 0.1vw solid #a81f24;
}
.clubminbox:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5); /* 添加阴影 */
  background-color: #a81f24; /* 添加背景色 */
  transform: scale(1); /* 轻微放大 */
}
.leftbox {
  position: relative;
  width: 35vw;
  height: 35vw;
  color: #fff;
  font-size: 1.5vw;
  left: 3vw;
}

.racetitle {
  position: relative;
  top: 3vw;
  left: 0vw;
  width: 35vw;
  height: 5vw;
  font-size: 2vw;
  font-weight: bold;
}
.clubdes {
  position: relative;
  top: 3vw;
  left: 0vw;
  width: 31vw;
  height: 15vw;
  font-size: 1.2vw;
}
.leftbox a {
  color: #fff;
  font-size: 1.7vw;
}

.midbox {
  position: absolute;
  top: 5vw;
  left: 39vw;
  font-size: 1.2vw;
  width: 25vw;
  color: #fff;
}
.rightbox {
  position: absolute;
  top: 5vw;
  left: 65vw;
  width: 25vw;
  height: 15vw;
}

.raceimg {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden; /* 超出部分隐藏 */
}

.raceimg img {
  width: auto; /* 图片宽度自适应 */
  height: 100%; /* 固定图片高度为容器高度 */
  object-fit: cover; /* 裁剪图片以保持比例 */
  display: block; /* 避免 inline 元素的默认行为 */
}

.clubbox a:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.5); /* 添加阴影 */
  background-color: #a81f24; /* 添加背景色 */
  transform: scale(1); /* 轻微放大 */
}


</style>



// WEBPACK FOOTER //
// src/components/clublist.vue